import type { JSX } from "react";
import * as React from "react";
import { Progress } from "../../../../domains/DrillProgress";
import OperatorInterface from "../../../../interfaces/OperatorInterface";
import StudentInterface from "../../../../interfaces/StudentInterface";
import type {
  StudyRecordWithRestrictedAttributes,
  UpdateStudyRecordQueryCache,
} from "../../../../interfaces/StudyRecordInterface";
import { Comment } from "./Comment";
import { Content } from "./Content";
import { Header } from "./Header";
import { Images } from "./Images";
import styles from "./styles.scss";
import TimelineItemFooter from "./TimelineItemFooter";

interface Props {
  currentOperator: OperatorInterface;
  student: StudentInterface;
  sectionId: string;
  studyRecord: StudyRecordWithRestrictedAttributes;
  canSendComment: boolean;
  showHeader?: boolean;
  updateStudyRecordQueryCache: UpdateStudyRecordQueryCache;
  isLastItem?: boolean;
  drillProgressMap?: Map<string, Progress>;
  isShowDrillAnswer?: boolean;
}

const TimelineItem = ({
  currentOperator,
  showHeader,
  student,
  studyRecord,
  sectionId,
  canSendComment,
  updateStudyRecordQueryCache,
  isLastItem = false,
  drillProgressMap,
  isShowDrillAnswer,
}: Props): JSX.Element => {
  return React.useMemo(() => {
    return (
      <div className={styles.root} data-testid="timeline-item">
        {showHeader && <Header student={student} studyRecord={studyRecord} />}
        <div className={styles.body}>
          {studyRecord.studyRecordImages.length > 0 && (
            <Images studyRecord={studyRecord} />
          )}
          <Comment studyRecord={studyRecord} />
          <Content
            studyRecord={studyRecord}
            student={student}
            sectionId={sectionId}
            showHeader={showHeader}
            drillProgressMap={drillProgressMap}
            isShowDrillAnswer={isShowDrillAnswer}
          />
        </div>
        <TimelineItemFooter
          currentOperator={currentOperator}
          studyRecord={studyRecord}
          student={student}
          canSendComment={canSendComment}
          updateStudyRecordQueryCache={updateStudyRecordQueryCache}
          isLastItem={isLastItem}
        />
      </div>
    );
  }, [studyRecord, drillProgressMap]);
};

export default TimelineItem;
